import {RemotePatchAuthRequest} from 'data/usecases/private/authorizations';
import {PatchAuthRequest} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makePatchAuthRequestStatus = (nuControle: string): PatchAuthRequest => {
	const url = AuthorizationsFlowEndpoints.register.replace(':nuControle', nuControle);
	return new RemotePatchAuthRequest(makeBFFApiUrl(url), makeAuthorizeHttpClientDecorator());
};
